import React from 'react';

export default function Support() {
  return (
    <div className="page">
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-8">
          <div className="card shadow-sm">
            <div className="card-body">
              <h1 className="h3 mb-4">Support</h1>
              
              <p className="mb-4">
                If you need assistance or have any questions about using Aullan Bro, 
                our support team is here to help.
              </p>

              <div className="mb-4">
                <h2 className="h5 mb-3">Contact Information</h2>
                
                <div className="mb-3">
                  <strong>Email:</strong>
                  <br />
                  <a href="mailto:support@aullan.com" className="text-decoration-none">
                    support@aullan.com
                  </a>
                </div>

                <div className="mb-3">
                  <strong>Phone:</strong>
                  <br />
                  <a href="tel:07770575133" className="text-decoration-none">
                    07770575133
                  </a>
                </div>
              </div>

              <div className="mb-4">
                <h2 className="h5 mb-3">Support Hours</h2>
                <p className="mb-0">
                  Our support team is available to assist you during business hours.
                  We aim to respond to all inquiries within 24-48 hours.
                </p>
              </div>

              <div className="alert alert-info" role="alert">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Note:</strong> For urgent technical issues, please contact us 
                via phone for faster assistance.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
